import type { BlockViewProps } from '../../core/types';

const lineStyle: React.CSSProperties = {
    width: '100%',
    height: '2px',
    background:
        'repeating-linear-gradient(90deg, #adb5bd 0 8px, transparent 0 12px)',
    position: 'absolute'
};

const labelStyle: React.CSSProperties = {
    padding: '4px 12px',
    backgroundColor: '#ffffff',
    border: '1px solid #adb5bd',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500',
    color: '#495057',
    position: 'relative',
    zIndex: 1
};

const containerStyle: React.CSSProperties = {
    margin: '10px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
};

export function SectionLandscapeBlockView(_props: BlockViewProps) {
    return (
        <div style={containerStyle}>
            <div style={lineStyle} />
            <div style={labelStyle}>SWITCH TO LANDSCAPE</div>
        </div>
    );
}
